<script setup>
	import { DsCarousel } from '@coloplast/design-system';
	import '@coloplast/design-system/dist/components/carousel/ds-carousel.css';

	const props = defineProps({
		vm: {
			type: Object,
			default: () => { },
		},
	});
</script>

<template>
	<DsCarousel ariaLabelNext="Next"
				ariaLabelPrev="Prev"
				:linkText="vm.CurrentBlock.RightBottomLinkText"
				:linkUrl="vm.BaseViewModel.RightBottomLinkUrl"
				linkTarget="_self"
				:maxItemsPerView="parseInt(props.vm.CurrentBlock.CardCountOnDesktop)">
		<template #header>
			<slot name="carouselheader"></slot>
		</template>
		<slot></slot>
	</DsCarousel>
</template>
